import { addIdentityRegionale } from './addIdentityRegionale'
import { getIdentityRegionale } from './getIdentityRegionale'
import { updateIdentityRegionale } from './updateIdentityRegionale'

const IdentityRegionaleSagas = [
    getIdentityRegionale,
    addIdentityRegionale,
    updateIdentityRegionale,
]

export default IdentityRegionaleSagas
